// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tree */
.file-manager__body-tree {
    flex-basis: 25%;
    order: 0;
    border-right: 1px solid #dee2e6;
    overflow: auto;
    flex-grow: 0;
    flex-shrink: 0;
    box-sizing: border-box;
}

.parent-container {
    padding-left: 14px;
    position: relative;
    padding: 0;
}

.child-parent-container {
    padding-left: 14px;
    left: 0;
    width: 100%;
}


.file-manager__body-tree li {
    height: 34px;
    list-style: none;
    padding-left: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    cursor: pointer;
}

.child-node .li-text-content {
    padding: 0 0 0 40px;
}

.li-text-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    pointer-events: none;

    -webkit-user-select: none;

            user-select: none;
    cursor: pointer;
    margin: 0;
    padding: 0 0 0 20px;
    z-index: 1;
}

.file-manager__body-tree .expand {
    z-index: 1;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}

.li-text-content em {
   font-size: 20px;
   color: #FDDD34;
   margin-right: 8px;
   position: relative;
}

.li-text-content span {
    margin-left: 8px;
}

.li-full-row {
    height: 34px;
    position: absolute;
    -webkit-user-select: none;
            user-select: none;
    box-sizing: border-box;
    cursor: pointer;
    left: 0;
    overflow: hidden;
    width: 100%;
}


li:hover > .li-full-row {
    background-color: #e9ecef;
    border-color: #e9ecef;
}

li.active .li-full-row {
    background-color: #0d6efd;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    opacity: 1;
    width: 100%;
}

li.active .li-text-content,
li.active .expand {
    color: #fff;
}

 em.shared {
    position: absolute;
    bottom: 0;
    left: 2px;
    z-index: 1;
    color: #d2a055;
    font-size: 14px;
 }`, "",{"version":3,"sources":["webpack://./app/src/js/components/filemanager/file-tree.css"],"names":[],"mappings":"AAAA,SAAS;AACT;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,cAAc;IACd,YAAY;IACZ,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;;IAEnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;;IAEnB,oBAAoB;;IAEpB,yBAAiB;;YAAjB,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;GACG,eAAe;GACf,cAAc;GACd,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;CAEC;IACG,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,cAAc;IACd,eAAe;CAClB","sourcesContent":["/* Tree */\n.file-manager__body-tree {\n    flex-basis: 25%;\n    order: 0;\n    border-right: 1px solid #dee2e6;\n    overflow: auto;\n    flex-grow: 0;\n    flex-shrink: 0;\n    box-sizing: border-box;\n}\n\n.parent-container {\n    padding-left: 14px;\n    position: relative;\n    padding: 0;\n}\n\n.child-parent-container {\n    padding-left: 14px;\n    left: 0;\n    width: 100%;\n}\n\n\n.file-manager__body-tree li {\n    height: 34px;\n    list-style: none;\n    padding-left: 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    cursor: pointer;\n}\n\n.child-node .li-text-content {\n    padding: 0 0 0 40px;\n}\n\n.li-text-content {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    pointer-events: none;\n\n    user-select: none;\n    cursor: pointer;\n    margin: 0;\n    padding: 0 0 0 20px;\n    z-index: 1;\n}\n\n.file-manager__body-tree .expand {\n    z-index: 1;\n    height: 34px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n}\n\n.li-text-content em {\n   font-size: 20px;\n   color: #FDDD34;\n   margin-right: 8px;\n   position: relative;\n}\n\n.li-text-content span {\n    margin-left: 8px;\n}\n\n.li-full-row {\n    height: 34px;\n    position: absolute;\n    user-select: none;\n    box-sizing: border-box;\n    cursor: pointer;\n    left: 0;\n    overflow: hidden;\n    width: 100%;\n}\n\n\nli:hover > .li-full-row {\n    background-color: #e9ecef;\n    border-color: #e9ecef;\n}\n\nli.active .li-full-row {\n    background-color: #0d6efd;\n    color: #fff;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-weight: 400;\n    opacity: 1;\n    width: 100%;\n}\n\nli.active .li-text-content,\nli.active .expand {\n    color: #fff;\n}\n\n em.shared {\n    position: absolute;\n    bottom: 0;\n    left: 2px;\n    z-index: 1;\n    color: #d2a055;\n    font-size: 14px;\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
